<template>
  <form id="id-recipient-language-form">
    <div class="form-group">
      <v-select 
        :value="agent"
        :options="onlineAgents"
        placeholder="-- Reassign Agent on Conversation --"
        @input="changeAgent"
      >
        <template #search="{attributes, events}">
          <input
            class="vs__search"
            v-bind="attributes"
            v-on="events"
          />
        </template>
      </v-select>
    </div>
    <div class="form-action bg-light px-3 py-3 d-flex flex-row-reverse">
      <button
        type="button"
        class="btn btn-info btn-rounded"
        @click="updateConversation"
        :disabled="httpPending"
      >
        <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
        <span v-else>Reassign</span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import VSelect from "vue-select";
import { EventBus } from "../../events/eventBus";

export default {
  name: "ConversationAgentForm",
  components: { VSelect },
  props: { operatorId: String, conversationId: String },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgencyId", "dialects", "availableAgents"]),
    onlineAgents() {
      const uniQueAvailableagents = this.availableAgents.reduce(
        (acc, current) => {
          const isDuplicate = acc.some((item) => item.agentId === current.agentId);

          if (!isDuplicate) {
            acc.push(current);
          }

          return acc;
        },
        []
      );
      return uniQueAvailableagents.filter((agent) => agent.agentId !== this.operatorId).map((agent) => { return {id: agent.agentId, label: agent.agentName}; });
    },
  },
  data() {
    return {
      agent: null,
      httpPending: false
    };
  },
  created() {
  },
  methods: {
    changeAgent(agent) {
      this.agent = agent;
    },
    async updateConversation() {
      if (this.agent.id) {
        this.httpPending = true;

        try {
          await this.$ConveyApi.conversationsApi.assignAgentToConversation({
            conversationId: this.conversationId,
            userId: this.agent.id,
          })
            .then(() => {
              this.$toastr("success", "Conversation Agent Reassigned");
              this.httpPending = false;
              EventBus.$emit("close-modal");
              this.$router.push({ name: "Conversations Dashboard" }).catch(()=>{});
            }).catch((err) => {
              /* eslint-disable */
              console.error(`Error updating conversation ${err}`);
              /* eslint-enable */
              this.$toastr("error", "Error Assigning Conversation Agent");
              this.httpPending = false;
            });
        } catch(e) {
          this.$toastr("error", "Error Assigning Conversation Agent");
          this.httpPending = false;
          return false;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.form-action {
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: -1rem;
  border-radius: 0 0 1rem 1rem;
}
</style>